import {createPluginFromSingleComponentPlugin} from '../../pluginsFactory'
import {pack} from './pack'
import {unpack} from './unpack'

export const labelPlugin = createPluginFromSingleComponentPlugin({
    name: 'LabelPlugin',
    components: new Set([
        'MenuButton',
        'AdminLoginButton',
        'FacebookShare',
        'PinterestFollow',
        'SiteButton',
        'ExitMobileMode',
        'PopupCloseTextButton',
        'FileUploader',
        'ImageButtonWithText',
        'MobuiButton',
        'MobuiPicker',
        'MobuiTextInput',
        'AddressInput',
        'HamburgerCloseButton',
        'HamburgerOpenButton',
        'RangeSlider',
        'SingleTab',
        'SlideshowButton',
        'StylableButton',
        'DashboardButton',
        'DashboardInput',
        'DashboardNumberInput',
        'DashboardTextButton',
        'DashboardToggleSwitch',
        'WbuAccordion',
        'WbuBackButton',
        'WbuButton',
        'WbuColorPicker',
        'WbuColorSelector',
        'WbuDatePicker',
        'WbuDrillDown',
        'WbuEmptyState',
        'WbuFontAndColorPicker',
        'WbuMultilineTextInput',
        'WbuNotificationBanner',
        'WbuToggleSwitch'
    ]),
    pack,
    unpack
})
